<template>
  <div class="q-radio" :class="{ disabled: disabled }">
    <div class="icon" :id="id" :class="getIconClass()" @mouseenter="setHover(true)" @mouseout="setHover(false)">
      <div class="inside"></div>
    </div>
    <div class="text" v-if="label">{{label}}</div>
  </div>
</template>
<script>
export default {
  name: 'radio',
  props: ['label', 'checked', 'disabled', 'id'],
  data () {
    return {
      hover: false
    }
  },
  methods: {
    getIconClass () {
      let result = null
      if (this.checked) {
        result = 'icon-radio_1'
      } else {
        result = 'icon-radio_0'
      }
      if (this.disabled) {
        result = result + ' disabled'
      } else {
        if (this.hover) {
          result = result + '_hover'
        }
      }
      return result
    },
    setHover (status) {
      this.hover = status
    }
  }
}
</script>
<style lang="scss" scoped>
.q-radio {
  display: inline-block;
  cursor: pointer;
  user-select: none;
  &.disabled {
    cursor: default;
    pointer-events: none;
  }
  >.icon {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    font-size: 20px;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  >.text {
    display: inline-block;
    color: #2f2f2f;
    margin-left: 4px;
    vertical-align: bottom;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/module/Radio.vue